import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import { persistStore, persistReducer, PersistConfig } from 'redux-persist';
import allReducers from './rootReducer';

export const rootReducer = (state: any, action: any) => {
  if (action.type === 'RESET_APP') {
    const { appInfo, forceUpdate } = state;
    console.log("app Info in root reducer : ", appInfo);
    state = { appInfo, forceUpdate };
  }

  return allReducers(state, action as never);
}

export const createRootStore = (
  persistConfig: PersistConfig<any>,
  appMiddlewares: any[] = []
) => {
  const isDevelopment = process.env['NODE_ENV'] === 'development';

  console.log("isDevelopment : ", isDevelopment);

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => {
      const defaultMiddleware = getDefaultMiddleware({
        serializableCheck: false,
      }).concat(appMiddlewares);
      // return isDevelopment
      //   ? defaultMiddleware.concat(logger)
      //   : defaultMiddleware;
      return defaultMiddleware;
    },
    devTools: isDevelopment,
    // preloadedState: initialRootState,
  });

  const persistor = persistStore(store);

  console.log("store initialized :", store);

  return { store, persistor };
};